import { render, staticRenderFns } from "./UdlGuidelineStrategyPanel.vue?vue&type=template&id=66e3b20b&scoped=true"
import script from "./UdlGuidelineStrategyPanel.vue?vue&type=script&lang=js"
export * from "./UdlGuidelineStrategyPanel.vue?vue&type=script&lang=js"
import style0 from "./UdlGuidelineStrategyPanel.vue?vue&type=style&index=0&id=66e3b20b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e3b20b",
  null
  
)

export default component.exports